var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalLoanInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27174",
    "data-name": "Group 27174",
    transform: "translate(-282 -361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    transform: "translate(282 361)",
    fill: "#fff",
    stroke: "#a6192e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9794",
    "data-name": "Path 9794",
    d: "M2.961,8.883V18h-1.6V8.883ZM3.3,6.021a1.019,1.019,0,0,1-.095.436,1.257,1.257,0,0,1-.252.36,1.157,1.157,0,0,1-.369.247,1.126,1.126,0,0,1-.445.09,1.062,1.062,0,0,1-.436-.09,1.132,1.132,0,0,1-.355-.247,1.228,1.228,0,0,1-.243-.36,1.062,1.062,0,0,1-.09-.436,1.126,1.126,0,0,1,.09-.445,1.2,1.2,0,0,1,.243-.369,1.132,1.132,0,0,1,.355-.248,1.063,1.063,0,0,1,.436-.09,1.126,1.126,0,0,1,.445.09,1.157,1.157,0,0,1,.369.248,1.221,1.221,0,0,1,.252.369A1.08,1.08,0,0,1,3.3,6.021Z",
    transform: "translate(290.34 360)",
    fill: "#a6192e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalLoanInfo);
export default __webpack_public_path__ + "static/media/digital-loan-info.47eeb5a45225085fe5fdee2b25fcf96f.svg";
export { ForwardRef as ReactComponent };